import React from 'react';

import { OAuthConfig as OAuthConfigInterface } from '@liscio/api';
import {
  StyledOAuthButtonShared as StyledOAuthButton,
  useOAuthV5Process,
} from '@liscio/common';
import { GoogleGIcon } from '@liscio/ui';

import {
  LOGIN_EVENTS,
  LOGIN_OAUTH_PROVIDERS,
  useTrackLoginEvent,
} from 'analytics/login/useTrackLoginEvent';
import { config } from 'config';

const PROVIDER = 'google';

export const GoogleOAuthV5Login = () => {
  const oAuthConfig: OAuthConfigInterface = config.oauth[PROVIDER];
  const trackLoginEvent = useTrackLoginEvent();

  const { initiateOAuth } = useOAuthV5Process({
    provider: PROVIDER,
    oAuthConfig,
  });

  return (
    <StyledOAuthButton
      type="button"
      onClick={() => {
        trackLoginEvent(LOGIN_EVENTS.OAUTH_BUTTON_CLICKED, {
          provider: LOGIN_OAUTH_PROVIDERS.GOOGLE,
        });
        initiateOAuth();
      }}
      variant="contained"
      startIcon={<GoogleGIcon fontSize="small" />}
      size="large"
    >
      Login with Google
    </StyledOAuthButton>
  );
};
